import React, { useEffect, useState } from "react";
import { Option } from "react-dropdown";

import "./style.scss";
import { LoadingOverlay, Loader } from "react-overlay-loader";
// import { Col, Row } from "react-bootstrap";
import { DocumentRequestList } from "./DocumentRequestList";
import { DocumentRequestDetailed } from "./DocumentRequestDetailed";
import { useDispatch, useSelector } from "react-redux";

import { initialDocumentPagination, DocumentRequestConstants } from "src/Core/Common/Constants";
import { ApplicationState } from "src/store";
import {
    fetchDocumentRequestList,
    getDocumentRequestDetail,
    listingDeleteDocumentRequest,
    resendDocumentAccesLink,
    resendDocumentAccesLinkDetailed,
    sendDocumentReminder,
} from "src/actionCreators/documentRequestActionCreators";
import {
    IDocumentRequestDetailedModel,
    IDocumentRequestListModel,
    IDocumentRequestListResponseModel,
    IDocumentRequestModel,
    IDocumentRequestSearchModel,
    initialDocumentListState,
    initialDocumentSearchState,
} from "src/Core/ViewModels/documentRequest/DocumentRequestModel";
import { ResourceIdLocators } from "src/helper/ResourceIdLocators";
import { fetchRetentionPeriods } from "src/actionCreators/folderActionCreators";
import { getRetentionOptions } from "src/helper/HelperFunctions";
import { DetailedStatus, FolderType, ListingStatus } from "src/Core/Common/Enums";
import { IFolderModel } from "src/Core/ViewModels/Folder/FolderModel";
import { fetchRetentionSettings } from "src/actionCreators/adminSettingsActionCreators";

export interface IDocumentRequestProps {
    isArchive?: boolean;
    folder?: IFolderModel;
    goToParentFolder?: (data: boolean) => void;
}
export const DocumentRequest: React.FC<IDocumentRequestProps> = props => {
    const {
        isArchive,
        folder,
        goToParentFolder,
    } = props;
    const dispatch = useDispatch();
    const documentState = useSelector((state: ApplicationState) => state.documentState);
    const [pagination, setPagination] = useState(initialDocumentPagination);
    const [selectedDocumentList, setSelectedDocumentList] = useState<IDocumentRequestListModel[]>([]);
    const [selectedDocument, setSelectedDocument] = useState<IDocumentRequestListModel>(initialDocumentListState);
    const [showDocumentDetail, toggleShowDocumentDetail] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [retentionPeriods, setRetentionPeriods] = useState<Option[]>([]);
    const [searchText, setSearchText] = useState<string>("");
    const [resetSortAndFilterOptions, callResetSortAndFilter] = useState(false);

    const fetchDocumentRequests = (documentRequestSearchModel: IDocumentRequestSearchModel, documentRequestId?: number) => {
        dispatch(fetchDocumentRequestList(documentRequestSearchModel, folder?.folderId ? folder?.folderId : FolderType.DOCUMENTREQUEST, documentRequestId, onFetchDocumentRequestComplete));
    };

    const retentionData = useSelector((appState: ApplicationState) => appState.folderState.retentionPeriodsData);

    useEffect(() => {
        dispatch(fetchRetentionPeriods());
        dispatch(fetchRetentionSettings());
    }, []);

    useEffect(() => {
        setRetentionPeriods(getRetentionOptions(retentionData.retentionPeriods));
    }, [retentionData]);

    const onFetchDocumentRequestComplete = (result: IDocumentRequestListResponseModel, documentRequestId?: number) => {
        if (result && result.documentRequests && result.documentRequests.length > 0) {
            setSelectedDocument(result.documentRequests[0]);
            dispatch(
                getDocumentRequestDetail(documentRequestId !== undefined ? documentRequestId : result.documentRequests[0].documentRequestId)
            );
        } else toggleShowDocumentDetail(false);
    };

    const documentRequestDetailCallback = (result: IDocumentRequestDetailedModel) => {
        setIsLoading(false);
        if (result) toggleShowDocumentDetail(true);
        else toggleShowDocumentDetail(false);
    };
    const handleGetDocumentDetail = (documentRequestId: number) => {
        setIsLoading(true);
        dispatch(getDocumentRequestDetail(documentRequestId, documentRequestDetailCallback));
    };
    const resetSelection = (documentStatus?: DetailedStatus, documentRequestId?: number, refreshDrl?: boolean, sortOrder?: string, sortColumn?: string, listingStatus?: ListingStatus) => {
        setSelectedDocumentList([]);
        const payload =
            refreshDrl === true
                ? {
                    ...initialDocumentSearchState,
                    pageNumber: initialDocumentPagination.currentPage,
                    pageSize: pagination.pageSize,
                }
                : {
                    ...initialDocumentSearchState,
                    pageNumber: pagination.currentPage,
                    pageSize: pagination.pageSize,
                    sortOrder: sortOrder ?? initialDocumentSearchState.sortOrder,
                    sortColumn: sortColumn ?? initialDocumentSearchState.sortColumn,
                    listingStatus: listingStatus ?? initialDocumentSearchState.listingStatus
                };

        fetchDocumentRequests(payload, selectedDocument.documentRequestId);
        toggleShowDocumentDetail(documentStatus === DetailedStatus.COMPLETED);
        setSelectedDocument(initialDocumentListState);
        refreshDrl && setPagination(initialDocumentPagination);
        setSearchText("");
        callResetSortAndFilter(prevState => !prevState);
    };

    const resetDocumentRequestSelection = () => {
        setSelectedDocumentList([]);
        const payload = {
            ...initialDocumentSearchState,
            pageNumber: pagination.currentPage,
            pageSize: pagination.pageSize
        };
        fetchDocumentRequests(payload);
        toggleShowDocumentDetail(false);
        setSearchText("");
        setSelectedDocument(initialDocumentListState);
        callResetSortAndFilter(prevState => !prevState);
    };

    const detailedActionSuccessCallback = (documentId: number) => {
        handleGetDocumentDetail(documentId);
    };
    const handleDocumentResendAccessLink = (documentRequestIds: number[], isListingAction?: boolean) => {
        if (isListingAction) {
            dispatch(
                resendDocumentAccesLink(
                    documentRequestIds,
                    isArchive ? ResourceIdLocators.MyFiles.MyFilesBtnRequestResendAccess : ResourceIdLocators.DRL.DRLListBtnResendAccess
                )
            );
        } else {
            dispatch(resendDocumentAccesLinkDetailed(documentRequestIds, ResourceIdLocators.DRL.DRLDtlBtnResendAccess));
        }
    };
    const handleDocumentDetailView = (result: boolean) => {
        if (result) toggleShowDocumentDetail(false);
    };
    const handleDocumentSendReminder = (documentRequestIds: number[], isListingAction = false, resourceId: string) => {
        if (isListingAction)
            dispatch(
                sendDocumentReminder(documentRequestIds, isListingAction, resourceId)
            );
        else dispatch(sendDocumentReminder(documentRequestIds, isListingAction, resourceId));
    };
    const handleDeleteDocumentRequest = () => {
        dispatch(
            listingDeleteDocumentRequest(
                selectedDocumentList,
                isArchive ? ResourceIdLocators.MyFiles.MyFilesBtnRequestDelete : ResourceIdLocators.DRL.DRLListBtnDeleteRequest,
                FolderType.DOCUMENTREQUEST,
                resetDocumentRequestSelection
            )
        );
    };

    return (
        <div className="message-list-wrapper search-box-no-border-radius my-files-request-padding">
            <DocumentRequestList
                documents={documentState.documentRequestList.documentRequests}
                totalDocuments={documentState.documentRequestList.totalRecords}
                pagination={pagination}
                isArchive={isArchive}
                folder={folder}
                selectedDocument={selectedDocument}
                setSelectedDocument={setSelectedDocument}
                selectedDocumentList={selectedDocumentList}
                setPagination={setPagination}
                getDocumentDetail={handleGetDocumentDetail}
                handleDeleteDocumentRequest={handleDeleteDocumentRequest}
                handleDocumentResendAccessLink={handleDocumentResendAccessLink}
                handleDocumentSendReminder={handleDocumentSendReminder}
                fetchDocumentRequests={fetchDocumentRequests}
                updateSelectedDocumentList={setSelectedDocumentList}
                resetSelection={resetSelection}
                resetSortAndFilterOptions={resetSortAndFilterOptions}
                searchText={searchText}
                setSearchText={setSearchText}
                goToParentFolder={goToParentFolder}
            />
            {showDocumentDetail && (
                <DocumentRequestDetailed
                    documentDetail={documentState.documentRequestDetailed.data}
                    isArchive={isArchive}
                    folder={folder}
                    handleDocumentResendAccessLink={handleDocumentResendAccessLink}
                    handleDocumentSendReminder={handleDocumentSendReminder}
                    resetSelection={resetSelection}
                    resetDocumentRequestSelection={resetDocumentRequestSelection}
                    detailedActionSuccessCallback={detailedActionSuccessCallback}
                    hideDocumentDetail={handleDocumentDetailView}
                    handleGetDocumentDetail={handleGetDocumentDetail}
                    retentionOptions={retentionPeriods} />
            )}
            <Loader loading={isLoading} />
        </div>
    );
};
